import TextCell from '@nile/banyan/src/Components/Tables/TextCell';
import DeleteCell from '@nile/client_management/src/Pages/Invoice/DeleteCell';
import { Column, getTranslatedText, SuperTable } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { Button, DisplayText } from '@superops/ui-design-system';
import React, { useEffect, useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDeliveryMapContext } from '../../Contexts/DeliveryMapContext';
import { ServiceCatalogModal } from '../ServiceCatalog/ServiceCatalogModal';
import { PriceCell } from '@nile/banyan/src/Pages/ServiceCatalogNew/ProductsAndServicesTable/Cells';
import { excludedServiceCatalogItemIds } from '../utils';

function BoldCell({ cell }) {
  return (
    <DisplayText element="div" size="large" weight="SemiBold">
      {cell.value ?? 'NA'}
    </DisplayText>
  );
}

const getColumns = (intl: any) => [
  {
    name: 'name',
    label: getTranslatedText(intl, 'common.serviceItem'),
    type: 'Text'
  },
  {
    name: 'description',
    label: getTranslatedText(intl, 'common.description'),
    type: 'Text'
  },
  {
    name: 'sellingPrice',
    label: getTranslatedText(intl, 'common.unitPrice'),
    type: 'Price'
  },
  {
    name: 'delete',
    label: ' ',
    type: 'Delete'
  }
];

export function ServiceItemTable({ serviceItems, setServiceCatalogItems }) {
  const [columnGroup, setColumnGroup] = useState([
    { Header: 'Name', header: 'name', columns: [] }
  ]);

  const [showServiceCatalogModal, setShowServiceCatalogModal] = useState(false);

  const { provisionRulesList, unProvisionedItems } = useDeliveryMapContext();

  const intl = useIntl();

  function onChange({
    miscProperty,
    miscItem
  }: {
    miscProperty: 'delete';
    miscItem: { itemId: string };
  }) {
    if (miscProperty === 'delete') {
      setServiceCatalogItems((items: Array<{ itemId: string }>) =>
        items.filter((item) => item.itemId !== miscItem.itemId)
      );
    }
  }

  async function onRecordsChange(newRecords: any) {
    setServiceCatalogItems(newRecords);
  }

  useEffect(() => {
    const group = getColumns(intl).map((col) => {
      return {
        Header: col.label,
        header: col.label,
        accessor: col.name,
        accessorKey: col.name,
        type: col.type,
        id: col.name,
        disableResizing: false,
        className: 'sticky',
        disableSortBy: true,
        editable: false,
        disableFilters: true,
        actions: {
          onChange
        },
        field: col
      };
    });

    setColumnGroup([{ Header: 'Name', header: 'Name', columns: group }]);
  }, []);

  const itemsToBeExcluded = useMemo(() => {
    return excludedServiceCatalogItemIds(
      provisionRulesList,
      unProvisionedItems
    );
  }, [provisionRulesList, unProvisionedItems]);

  return (
    <div>
      <ServiceCatalogModal
        open={showServiceCatalogModal}
        closeModal={() => setShowServiceCatalogModal(false)}
        onRecordsChange={onRecordsChange}
        serviceItems={serviceItems}
        itemsToBeExcluded={itemsToBeExcluded}
      />
      <Column gap={10}>
        <div className="fx space-between">
          <DisplayText element="div" size="large">
            <FormattedMessage id="common.serviceItems" />
          </DisplayText>

          <Button
            icon={<SVGIcon name="Add" />}
            onClick={() => setShowServiceCatalogModal(true)}
          >
            <FormattedMessage id="common.add" />
          </Button>
        </div>

        <div className="height300">
          <SuperTable
            context={{
              records: [],
              viewConditions: null
            }}
            columns={columnGroup}
            data={serviceItems}
            rowCount={50}
            refreshTable={() => {}}
            defaultColumnCells={{
              Text: TextCell,
              Delete: DeleteCell,
              Bold: BoldCell,
              Price: PriceCell
            }}
            noBulkSelect
          />
        </div>
      </Column>
    </div>
  );
}
